import * as React from "react";
import TicketEventContainer from "app/components/AppComponents/TicketEvents/TicketEventContainer";

export default class TicketEventsSummary extends React.Component<any> {
  getBackPath() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const from = searchParams.get("from");

    if (from === "all") {
      return "/snapscan/events/all";
    }

    return "/snapscan/events/review_queue";
  }

  render() {
    const id = this.props.match.params.id;
    const backPath = this.getBackPath();

    return (
      <TicketEventContainer
        id={id}
        setHeader={this.props.setHeader}
        history={this.props.history}
        backPath={backPath}
      />
    );
  }
}
